import {
  useContext, useEffect, useRef, useState,
} from 'react';
import { Link } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';

import ApiImportIcon from 'assets/icons/apiImport.svg';
import ArrowLeftIcon from 'assets/icons/longArrowLeft.svg';
import InfoCircleIcon from 'assets/icons/infoCircle.svg';
import { StoreContext, ImportSectionEnum } from 'models/import';
import { ThemeName } from 'models/theme';
import ImportSteps from 'pages/import/shared/steps';
import Alert from 'components/alert';
import Btn, { BtnModifier } from 'components/btn';
import FormCheckbox, { FormCheckboxProps } from 'components/form/checkbox';
import FormRadio, { FormRadioProps } from 'components/form/radio';
import FormTextfield, { FormTextfieldProps } from 'components/form/textfield';
import DropZone from 'components/dropzone';
import ContentBlock, { ContentBlockModifier } from 'components/contentBlock';
import Dropdown from 'components/dropdown';
import InfoBox from 'components/infoBox';
import InfoSteps from 'components/infoSteps';
import Actions, { ActionModifier } from 'components/actions';
import ApiCard, { ApiCardData, ApiCardStatusEnum } from 'components/apiCard';
import { DealItem } from 'models/partner';
import DealCard, { DealModifier } from 'components/dealCard';
import Skeleton from 'components/skeleton';
import Banner from 'components/banner';
import ImportTable from 'components/table/importTable';
import BalanceTable from 'components/table/balanceTable';
import Pill, { PillModifier } from 'components/pill';
import DefinitionBlock, { DefinitionBlockItem } from 'components/definitionBlock';
import ApiTable from 'components/table/apiTable';
import CsvPreviewTable from 'components/table/csvPreviewTable';
import Modal, { ModalModifier } from 'components/modal';
import UiForm from './components/uiForm';

function Ui() {
  const formMethods = useForm({ mode: 'onChange' });
  const { setActiveSection, themeName, setThemeName } = useContext(StoreContext);
  const ref = useRef<HTMLDivElement>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setActiveSection({ data: ImportSectionEnum.FORM, ref: ref.current });
  }, []);

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('themeName', themeName);
  }, [themeName]);

  const changeTheme = (name: ThemeName) => {
    setThemeName(name);

    const root = document.querySelector('html');

    if (root) {
      root.dataset.theme = name;
    }
  };

  const dummyText = 'Test test test';

  const infoStepsData = [
    {
      title: 'Step 1',
      content: (
        <>
          Some content
          <a href="./">with a dummy link</a>
        </>
      ),
    },
    {
      title: 'Step 2',
      content: (
        <>
          Some more content
          <strong>with a strong element</strong>
        </>
      ),
    },
    {
      title: 'Step 3',
      content: 'string',
    },
  ];

  const textfieldData: FormTextfieldProps[] = [
    {
      name: 'api_key',
      options: { maxLength: 2 },
      label: 'API Key',
      placeholder: 'Enter your API Key',
    },
    {
      name: 'api_secret',
      options: { disabled: true },
      label: 'Secret',
      placeholder: 'Enter your Secret',
    },
  ];

  const radioData: FormRadioProps = {
    name: 'radioName',
    items: [
      { label: 'API Import', value: 'api' },
      { label: 'Legacy API Import', value: 'api_legacy' },
    ],
  };

  const checkboxData: FormCheckboxProps[] = [
    {
      name: 'import_trades_1',
      label: 'Trades 1',
      narrow: true,
    },
    {
      name: 'import_trades_2',
      options: { disabled: true },
      label: 'Trades 2',
    },
  ];

  const toggleData: FormCheckboxProps[] = [
    {
      name: 'auto',
      label: 'Automatic sync (Daily)',
      toggle: true,
    },
    {
      name: 'manual',
      options: { disabled: true },
      label: 'Manual sync',
      toggle: true,
    },
  ];

  const apiCardData: ApiCardData = {
    logoUrl: 'https://cointracking.info/img/logos/binance.png',
    key: '9On4TqvxugYbMaHTkSazio5ZuULELQLn6depRQtceExhq9irIbp5Nc0oNQ7Mr4y8',
    customName: 'Binance 1',
    details: [
      { key: 'Created', value: '07.02.2022 13:26' },
      { key: 'Last sync', value: '07.02.2022 13:26' },
      { key: 'Last import', value: '23.02.2022 19:15' },
      { key: 'Trade Pairs', value: '343' },
      { key: 'Mail', value: '-' },
      { key: 'Label', value: '-' },
    ],
    status: {
      type: ApiCardStatusEnum.ERROR,
      message: 'some error',
    },
    autosync: true,
  };

  const onDrop = (acceptedFiles: File[]) => {
    // if (!acceptedFiles || !acceptedFiles.length) return;
    // Do something with the files
    // eslint-disable-next-line no-console
    console.log(acceptedFiles);
  };

  const dealData: DealItem = {
    id: 1,
    position: null,
    accessible_pro_status_ids: [null, 0, 1, 2],
    partner: {
      name: 'gemini',
      display_name: 'Gemini',
      logo_uri: 'https://cointracking.info/img/logos/gemini.png',
      top_partner: false,
    },
    headline: '$20 in BTC',
    selling_points: ['Get $25 in CRO tokens'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid harum non modi itaque nobis possimus optio maxime. Eum dolore, labore quam velit obcaecati alias, molestias porro explicabo quod hic possimus.',
    expiry_date: '2021-05-30',
    category: {
      name: 'exchanges',
      display_name: 'Exchanges',
      position: null,
    },
    tags: [
      {
        name: 'limited-offer',
        display_name: 'Limited Offer',
        position: null,
      },
      {
        name: 'discount',
        display_name: 'Discount',
        position: null,
      },
    ],
  };

  const dealData2: DealItem = {
    id: 1,
    position: null,
    accessible_pro_status_ids: [null, 0, 1, 2],
    partner: {
      name: 'gemini',
      display_name: 'Gemini',
      logo_uri: 'https://cointracking.info/img/logos/gemini.png',
      top_partner: true,
    },
    headline: '$20 in BTC',
    selling_points: ['Get $25 in CRO tokens', 'Get $35 in Cash'],
    description:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquid harum non modi itaque nobis possimus optio maxime. Eum dolore, labore quam velit obcaecati alias, molestias porro explicabo quod hic possimus.',
    expiry_date: '2021-05-30',
    category: {
      name: 'exchanges',
      display_name: 'Exchanges',
      position: null,
    },
    tags: [
      {
        name: 'limited-offer',
        display_name: 'Limited Offer',
        position: null,
      },
      {
        name: 'discount',
        display_name: 'Discount',
        position: null,
      },
    ],
  };

  const definitionBlockData: DefinitionBlockItem[] = [
    { definition: 'some definition ', value: 'some value' },
    { definition: 'some definition asd dasdgf', value: 'some value 123' },
  ];

  return (
    <>
      <div className="ct_section _padded">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <div
              style={{
                position: 'fixed',
                top: '0',
                width: '100%',
                background: 'white',
                zIndex: '1000',
              }}
            >
              <Btn
                type="secondary"
                text="Light Theme"
                onClick={() => changeTheme(ThemeName.LIGHT)}
              />
              <Btn
                type="secondary"
                text="Dark Theme"
                onClick={() => changeTheme(ThemeName.DARK)}
              />
              <Btn
                type="secondary"
                text="Dimmed Theme"
                onClick={() => changeTheme(ThemeName.DIMMED)}
              />
              <Btn
                type="secondary"
                text="Black Theme"
                onClick={() => changeTheme(ThemeName.BLACK)}
              />
            </div>

            <Banner
              title="Premium Account"
              headline="Do you want more exclusive benefits?"
              subline="Upgrade your account to Premium"
              btnText="Upgrade now"
            />
          </div>
        </div>
      </div>
      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <UiForm />
          </div>
        </div>
      </div>

      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <FormProvider {...formMethods}>
              <form className="ct_form">
                {/* <div className="ct_form-row">
                  <div className="ct_form-col">
                    <FormSelect
                      groups={fromSelectData}
                      filterByKey="label"
                      labelKey="label"
                      valueKey="value"
                      value="aa"
                      clearable
                      searchable
                    />
                  </div>
                </div>

                <div className="ct_form-row">
                  <div className="ct_form-col">
                    <FormTextfield {...textfieldData[0]} />
                  </div>
                </div> */}

                <div className="ct_form-row">
                  <div className="ct_form-col">
                    <FormTextfield {...textfieldData[1]} />
                  </div>
                </div>

                <FormRadio {...radioData} />

                <div className="ct_form-row">
                  <div className="ct_form-col">
                    <FormCheckbox {...checkboxData[0]} />
                  </div>
                </div>

                <div className="ct_form-row">
                  <div className="ct_form-col">
                    <FormCheckbox {...checkboxData[1]} />
                  </div>
                </div>

                <div className="ct_form-row">
                  <div className="ct_form-col">
                    <FormCheckbox {...toggleData[0]} />
                  </div>
                </div>

                <div className="ct_form-row">
                  <div className="ct_form-col">
                    <FormCheckbox {...toggleData[1]} />
                  </div>
                </div>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>

      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <DefinitionBlock title="History" icon={<InfoCircleIcon />} items={definitionBlockData} />
          </div>
        </div>
      </div>

      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <Pill value="ACTIVE" modifiers={[PillModifier.ACTIVE]} />
            <Pill value="ERROR" modifiers={[PillModifier.ERROR]} />
            <Pill value="PROGRESS" modifiers={[PillModifier.PROGRESS]} />

            <Pill value="NEUTRAL" modifiers={[PillModifier.NEUTRAL]} />
            <Pill value="NEUTRAL HOVER" modifiers={[PillModifier.NEUTRAL, PillModifier.HOVER]} />

            <Pill value="TABLE" modifiers={[PillModifier.TABLE]} />
            <Pill value="OUTLINE" modifiers={[PillModifier.OUTLINE]} />
          </div>
        </div>
      </div>

      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <br />
            <Btn onClick={() => setShowModal(true)} type="primary" text="Show CSV Preview" />
            <Modal
              showModal={showModal}
              headline="Data Preview: Your Binance Transactions"
              description="Check if your trades are correct."
              onModalClose={() => setShowModal(false)}
              onModalAction={() => false}
              isLoading={false}
              modifiers={[ModalModifier.WIDE]}
            >
              <CsvPreviewTable />
            </Modal>
          </div>
        </div>
      </div>

      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <br />
            <ImportTable />
          </div>
        </div>
      </div>

      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <br />
            <BalanceTable requestUri="/tx-overview-v1/platform/balance?platform-type=exchange&platform-name=gemini&wallet-address=" />
          </div>
        </div>
      </div>
      <div className="ct_section">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <br />
            <ApiTable />
          </div>
        </div>
      </div>
      <div className="ct_section _import">
        <div className="ct_section-inner">
          <div className="ct_section-main">
            <div style={{ display: 'flex' }}>
              <div style={{ width: '50%', padding: '0px 10px' }}>
                <Skeleton height="450px" />
              </div>
              <div style={{ width: '50%', padding: '0px 10px' }}>
                <Skeleton />
              </div>
            </div>

            <div style={{ display: 'flex' }}>
              <div style={{ width: '50%', padding: '0px 10px' }}>
                <DealCard deal={dealData} />
              </div>
              <div style={{ width: '50%', padding: '0px 10px' }}>
                <DealCard deal={dealData2} modifier={DealModifier.FEATURED} />
              </div>
            </div>
            <ApiCard data={apiCardData} />

            <Link to="/" className="ct_link _nav">
              <ArrowLeftIcon />
              Back
            </Link>

            <Dropdown title="Dropdown title">
              <DropZone onDrop={onDrop} />
            </Dropdown>

            <div ref={ref}>
              <ContentBlock
                title="Main ContentBlock"
                desc="Some description"
                modifiers={[ContentBlockModifier.MAIN]}
              >
                <DropZone onDrop={onDrop} />
              </ContentBlock>
            </div>

            <ContentBlock
              title="ContentBlock with sub mod"
              desc="e.g. used in advanced import settings"
              modifiers={[ContentBlockModifier.SUB]}
            >
              <div>Any Component</div>
            </ContentBlock>

            <ContentBlock
              title="ContentBlock with sub mod without desc"
              modifiers={[ContentBlockModifier.SUB]}
            >
              <div>Any Component</div>
            </ContentBlock>

            <Actions modifiers={[ActionModifier.RIGHT, ActionModifier.NARROW]}>
              <Btn type="secondary" text="Cancel" />
              <Btn type="primary" text="Continue" />
            </Actions>

            <div>
              <Btn type="primary" text="Primary without icon" />
              <Btn
                type="primary"
                disabled
                text="Primary disabled"
                icon={<ApiImportIcon />}
              />
            </div>
            <div>
              <Btn
                type="primary"
                text="Primary with icon left"
                icon={<ApiImportIcon />}
              />
              <Btn
                type="primary"
                text="Primary with icon right"
                icon={<ApiImportIcon />}
                iconRight
              />
            </div>

            <div>
              <Btn type="secondary" text="Secondary without icon" />
              <Btn
                type="secondary"
                disabled
                text="Secondary disabled"
                icon={<ApiImportIcon />}
              />
            </div>
            <div>
              <Btn
                type="secondary"
                text="Secondary with icon left"
                icon={<ApiImportIcon />}
              />
              <Btn
                type="secondary"
                text="Secondary with icon right"
                icon={<ApiImportIcon />}
                iconRight
              />
            </div>

            <div>
              <Btn
                type="primary"
                text="Primary Big"
                icon={<ApiImportIcon />}
                modifier={[BtnModifier.BIG]}
              />
            </div>

            <div>
              <Btn type="link" text="Link Button" icon={<ApiImportIcon />} />
              <Btn type="link" icon={<ApiImportIcon />} />
            </div>

            <Alert type="success" hasArrow title="Success">
              {dummyText}
            </Alert>
            <Alert type="info" hasArrow title="Info">
              {dummyText}
            </Alert>
            <Alert type="warning" hasArrow={false} title="Warning">
              {dummyText}
            </Alert>
            <Alert type="error" hasArrow={false} title="Error">
              {dummyText}
            </Alert>

            <InfoBox title="Instructions" icon={<InfoCircleIcon />}>
              <Alert type="warning" hasArrow={false} title="Warning">
                {dummyText}
              </Alert>
              <InfoSteps items={infoStepsData} />
            </InfoBox>
          </div>
          <div className="ct_section-aside">
            <ImportSteps />
          </div>
        </div>
      </div>
      <div className="ct_section">
        <div className="ct_section-inner">
          <ApiCard data={apiCardData} />
        </div>
      </div>
    </>
  );
}

export default Ui;
